import pythonApiClient from './pythonBaseApi';

const eliminarReservasApi = {
  // Descargar Excel con reservas actuales
  descargarReservasActuales: async () => {
    const response = await pythonApiClient.get('/procesos/hoteleria/eliminar-reservas/descargar-reservas-actuales', {
      responseType: 'blob'
    });
    return response;
  },

  // Buscar reserva por DNI (sin eliminar)
  buscarReservaPorDni: async (dni) => {
    const response = await pythonApiClient.get('/procesos/hoteleria/eliminar-reservas/buscar-reserva', {
      params: { dni }
    });
    return response;
  },

  // Eliminar reserva individual
  eliminarReservaIndividual: async (dni) => {
    const response = await pythonApiClient.post('/procesos/hoteleria/eliminar-reservas/eliminar-individual', {
      dni
    });
    return response;
  },

  // Eliminar reservas masivas
  eliminarReservasMasiva: async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    
    const response = await pythonApiClient.post('/procesos/hoteleria/eliminar-reservas/eliminar-masiva', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response;
  },

  // Eliminar todas las reservas
  eliminarTodasReservas: async (confirmacion) => {
    const response = await pythonApiClient.post('/procesos/hoteleria/eliminar-reservas/eliminar-todas', {
      confirmacion
    });
    return response;
  }
};

export default eliminarReservasApi;
